import { createUseStyles } from 'react-jss';
const $space = '';
export const useAmbassadorForYouStyles = createUseStyles({
  '@global': {
    '.slick-slider': {
      width: '100%',
    },
    '.slick-slide': {
      width: '230px',
    },
    '.slick-arrow': {
      zIndex: '10',
      top: '45%',

      '&:hover': {
        opacity: '100%',
      },
      '@media (min-width: 500px)': {
        top: '45%',
      },

      '@media (min-width: 1024px)': {
        top: '45%',
      },
    },

    '.slick-prev': {
      left: '5%',
      '@media (min-width: 1024px)': {
        left: '5%',
      },
      '&:before': {
        content: `'${$space}'`,
      },
    },

    '.slick-next': {
      right: '5%',
      '@media (min-width: 1024px)': {
        right: '5%',
      },
      '&:before': {
        content: `'${$space}'`,
      },
    },
  },
  AmbassadorForYouCarousel: {
    '& .slick-next:before': {
      content: `'${$space}'`,
    },

    '& li': {
      '& button': {
        borderColor: '#0057b7',
      },
      '&.slick-active': {
        background: '#0057b7',
        borderColor: '#0057b7',
        transform: 'scale(1)',
      },
    },
  },
});
